import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import querystring from 'query-string';

export default function addPromotion(params) {
    const { baseUrl, brandId, country, promotionCode, uberToken, clientId, clientSecret, langId, additionalHeaders = {} } = params;

    invariant(baseUrl, 'baseUrl is a required param of addPromotion()');
    invariant(brandId, 'brandId is a required param of addPromotion()');
    invariant(country, 'country is a required param of addPromotion()');
    invariant(promotionCode, 'promotionCode is a required param of addPromotion()');
    invariant(uberToken, 'uberToken is a required param of addPromotion()');
    invariant(clientId, 'clientId is a required param of addPromotion()');

    const headers = { 'Content-Type': 'application/json', ...additionalHeaders };
    const query = querystring.stringify({ langId });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart/@self/assigned_promotion_code/${encodeURIComponent(promotionCode)}${
        query ? `?${query}` : ''
    }`;

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'PUT' }), uberToken, clientId, clientSecret),
        'addPromotion',
    );
}
